import EditModals from "admin-panel/reservation/Modals";
import { BsPencilSquare, BsEye, BsTrash } from "react-icons/bs";

export default function Card({
  index,
  type,
  data,
  payModal,
  editHandler,
  cancelFactor,
}) {
  // types : reserve - order

  return (
    <>
      <div
        className={`card-item-tabs d-flex flex-wrap ${
          index % 2 !== 0 && "is-dark-blue"
        }`}
      >
        {data.map((value, ind) => (
          <div key={`card-${ind}`}>
            <div className="title">{value.title}</div>
            <div className="description">{value.description}</div>
          </div>
        ))}
        <div>
          <div className="title">عملیات</div>
          {type == "reserve" && (
            <div className="description">
              <span
                style={{ cursor: "pointer" }}
                onClick={payModal}
                data-bs-toggle="modal"
                data-bs-target="#payModal"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33.015"
                  height="20.985"
                  viewBox="0 0 33.015 32.985"
                >
                  <g
                    id="Icon_feather-link"
                    data-name="Icon feather-link"
                    transform="translate(-1.493 -1.508)"
                  >
                    <path
                      id="Path_189"
                      data-name="Path 189"
                      d="M15,19.5a7.5,7.5,0,0,0,11.31.81l4.5-4.5A7.5,7.5,0,1,0,20.2,5.2L17.625,7.77"
                      fill="none"
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="3"
                    />
                    <path
                      id="Path_190"
                      data-name="Path 190"
                      d="M21,16.5a7.5,7.5,0,0,0-11.31-.81l-4.5,4.5A7.5,7.5,0,1,0,15.8,30.8L18.36,28.23"
                      fill="none"
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="3"
                    />
                  </g>
                </svg>
              </span>
              <BsTrash
                onClick={cancelFactor}
                style={{ fontSize: "20px", marginRight: "10px" , cursor: "pointer"}}
              />
              <BsPencilSquare
                data-bs-toggle="modal"
                data-bs-target="#add-edit-reserve"
                style={{ fontSize: "20px", marginRight: "10px", cursor: "pointer" }}
                onClick={editHandler}
              ></BsPencilSquare>
            </div>
          )}
          {type == "order" && (
            <div className="description">
              <BsEye
                data-bs-toggle="modal"
                data-bs-target="#show-reserve"
                style={{ fontSize: "20px", marginRight: "10px", cursor: "pointer" }}
                onClick={editHandler}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
